/**
 * CORS 헤더를 보내지 않는 외부 호스트의 이미지를 백엔드 image-proxy를 통해 우회.
 * add-adjust-guide 다운로드 등 캔버스 캡처 시 cross-origin 거절로 인한 tainted를 방지한다.
 *
 * 백엔드(`/image-proxy/?url=...`)에 호스트 화이트리스트가 있어 무관한 호스트는 통과시키지 않는다.
 */

const EXTERNAL_HOSTS_NEEDING_PROXY = new Set([
  "imaginary-mgpfodfl5q-an.a.run.app",
  "storage.googleapis.com",
  "mash-starttool.s3.ap-northeast-2.amazonaws.com",
]);

const BASE_API_URL = (import.meta.env.VITE_BASE_API_URL as string | undefined) ?? "/";

export function toProxiedImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;

  let host: string;
  try {
    host = new URL(url, window.location.origin).host;
  } catch {
    return url;
  }
  if (!EXTERNAL_HOSTS_NEEDING_PROXY.has(host)) return url;

  const base = BASE_API_URL.endsWith("/") ? BASE_API_URL : `${BASE_API_URL}/`;
  return `${base}image-proxy/?url=${encodeURIComponent(url)}`;
}
